/* /pages/whydm01 — page-scoped behaviour.
   Loaded only by sections/whydm01.liquid. No-ops immediately if the page root
   is absent, so it can never act on another template.

   1. header logo click -> reload (keeps the visitor on the landing page),
      replicating assets/whyhj-lp.js
   2. carousels — desktop: arrow, manual only, loops. mobile: native swipe with
      scroll-snap (no arrow, per Figma) driving a progress bar.
   3. mobile sticky bar — same mechanics as sections/sticky-cta-whyhj.liquid.

   Ingredient accordions are native <details>/<summary> and need no JS.
*/
(function () {
  'use strict';

  var root = document.getElementById('whydm01-root');
  if (!root) return;

  var MOBILE = '(max-width: 767px)';
  var isMobile = function () { return window.matchMedia(MOBILE).matches; };

  /* ---- 1. Logo click keeps the visitor on the page ---------------------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('header .header__heading-link');
    if (!link) return;
    e.preventDefault();
    window.location.reload();
  });

  /* ---- 2. Carousels -----------------------------------------------------
     Desktop: manual arrow, infinite, always moving RIGHT with no reset the eye
     can catch. The earlier clone-and-jump approach still showed a snap at the
     wrap, so this rotates the DOM instead: each press animates the track exactly
     one slide left, then — once that transition finishes — the first slide is
     moved to the end and the track is put back to translateX(0) with the
     transition suppressed. Because the DOM rotated by one, translateX(0) shows
     precisely what -1 step was showing, so nothing moves on screen. The offset
     never accumulates, so there is never a long slide back.
     Mobile: native swipe with scroll-snap, driving Figma's dot indicator. */
  root.querySelectorAll('[data-whydm01-carousel]').forEach(function (el) {
    var track = el.querySelector('[data-whydm01-track]');
    var next = el.querySelector('[data-whydm01-next]');
    var dotsWrap = el.querySelector('[data-whydm01-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    if (!track) return;

    var original = Array.prototype.slice.call(track.children);
    var count = original.length;
    if (!count) return;

    var pos = 0;            // logical index of the leftmost visible slide
    var busy = false;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return track.children[0].getBoundingClientRect().width + gap;
    }
    function paintDots(i) {
      if (!dots.length) return;
      var a = ((i % dots.length) + dots.length) % dots.length;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === a); });
    }
    function settle() {
      // rotate one slide front -> back, then cancel the offset invisibly
      track.appendChild(track.children[0]);
      track.style.transition = 'none';
      track.style.transform = 'translateX(0px)';
      void track.offsetWidth;                 // commit before the transition returns
      track.style.transition = '';
      busy = false;
    }

    if (next) {
      next.addEventListener('click', function () {
        if (busy || isMobile()) return;
        busy = true;
        pos = (pos + 1) % count;
        paintDots(pos);

        var done = function (e) {
          if (e && (e.target !== track || e.propertyName !== 'transform')) return;
          track.removeEventListener('transitionend', done);
          clearTimeout(guard);
          settle();
        };
        var guard = setTimeout(function () {   // reduced motion / no transitionend
          track.removeEventListener('transitionend', done);
          settle();
        }, 600);
        track.addEventListener('transitionend', done);

        track.style.transition = '';
        track.style.transform = 'translateX(' + -step() + 'px)';
      });
    }

    var vpEl = track.parentElement;
    vpEl.addEventListener('scroll', function () {
      if (!isMobile() || !dots.length) return;
      paintDots(Math.round(vpEl.scrollLeft / step()));
    }, { passive: true });

    function reset() {
      // put the slides back in their authored order so the first review is first
      original.forEach(function (n) { track.appendChild(n); });
      track.style.transition = 'none';
      track.style.transform = 'translateX(0px)';
      void track.offsetWidth;
      track.style.transition = '';
      vpEl.scrollLeft = 0;
      pos = 0; busy = false;
      paintDots(0);
    }
    /* Slides past the first are clipped by the viewport, so `loading="lazy"` never fires
       for them and they would flash blank the first time you reach them. Warm them once
       the page has settled — after first paint, so nothing is delayed. */
    function warm() {
      track.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        if (!img.naturalWidth) { var src = img.getAttribute('src'); img.setAttribute('src', src); }
      });
    }
    if (next) next.addEventListener('click', warm, { once: true });
    vpEl.addEventListener('touchstart', warm, { once: true, passive: true });
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 });
    else setTimeout(warm, 1500);

    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(reset, 150); }, { passive: true });
    reset();
  });

  /* ---- 2b. Press-logo ticker ---------------------------------------------
     whyhj-lp's logo strip is the shared logo-section-home rendered as a bxSlider
     ticker. That section isn't on this page, so its init never runs — this
     reproduces it with the same options. jQuery and jquery.bxslider.min.js are
     both already loaded globally by layout/theme.liquid. Scoped to this page's
     root so it can never touch another .bxslider elsewhere. */
  (function initLogoTicker(tries) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.bxSlider) {
      if ((tries || 0) < 40) return setTimeout(function () { initLogoTicker((tries || 0) + 1); }, 100);
      return;                                   // bxSlider absent: static row, still fine
    }
    var list = root.querySelector('.whydm01-logos .bxslider');
    if (!list || list.dataset.whydm01Ticker) return;
    list.dataset.whydm01Ticker = '1';
    $(list).bxSlider({ minSlides: 5, maxSlides: 8, slideMargin: 0, ticker: true, speed: 30000 });
  })(0);

  /* ---- 3. Mobile sticky bar --------------------------------------------- */
  var sticky = root.querySelector('[data-whydm01-sticky]');
  if (sticky) {
    var threshold = parseInt(sticky.getAttribute('data-threshold'), 10) || 600;
    var onScroll = function () {
      if (window.pageYOffset > threshold) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Hide the sticky bar while the offer's own CTA is on screen, so the visitor never
       sees two competing buttons at once (Christina). */
    /* Retire the bar once the visitor reaches the end of the page — either the offer's own
       button or the footer is on screen. Watching the footer too means the bar is never up
       while the footer is visible, so the footer needs no clearance underneath it and the
       long empty strip at the bottom goes away (Christina). */
    if ('IntersectionObserver' in window) {
      var ends = [root.querySelector('.whydm01-offer__cta .whydm01-btn'),
                  document.querySelector('#shopify-section-footer .footer')].filter(Boolean);
      var seen = new WeakSet();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? seen.add(en.target) : seen.delete(en.target); });
        sticky.classList.toggle('is-at-cta', ends.some(function (n) { return seen.has(n); }));
      }, { threshold: 0.01 });
      ends.forEach(function (n) { io.observe(n); });
    }
  }
})();
